'use client';

import { c as _c } from "react/compiler-runtime";
import type { PreComputedFilterOfferIds } from '@cc-shopping/contracts/credit-cards-page/roundup/types';
import { createContext, useContext, useMemo } from 'react';
import { useStoreWithEqualityFn } from 'zustand/traditional';
import { createOffersFilterStore } from '.';
import type { OffersFilterStoreState } from './types';
export const OffersFilterStoreContext = createContext<ReturnType<typeof createOffersFilterStore> | null>(null);
type Props = {
  areFiltersEnabled: boolean;
  preComputedFilterOfferIds: PreComputedFilterOfferIds;
};
export function OffersFilterStoreProvider(props) {
  const $ = _c(6);
  const {
    areFiltersEnabled: t0,
    preComputedFilterOfferIds,
    children
  } = props;
  const areFiltersEnabled = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== areFiltersEnabled || $[1] !== preComputedFilterOfferIds) {
    t1 = createOffersFilterStore({
      areFiltersEnabled,
      preComputedFilterOfferIds
    });
    $[0] = areFiltersEnabled;
    $[1] = preComputedFilterOfferIds;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const store = t1;
  let t2;
  if ($[3] !== children || $[4] !== store) {
    t2 = <OffersFilterStoreContext.Provider value={store}>{children}</OffersFilterStoreContext.Provider>;
    $[3] = children;
    $[4] = store;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function useOffersFilterStore(selector, equalityFn) {
  const store = useContext(OffersFilterStoreContext);
  if (!store) {
    throw new Error("Missing OffersFilterStoreProvider in the tree");
  }
  return useStoreWithEqualityFn(store, selector, equalityFn);
}